export default __webpack_public_path__ + "static/media/Marta.5cad711d.jpg";